<template>
  <div>
    <v-row class="pl-6 ma-0 bt-line condition-wrap">
      <!-- 시간 -->
      <v-col
        cols="12"
        class="pa-0 pb-1 mt-3 d-flex justify-space-between"
        @click="toSelectDate"
      >
        <span class="label">근무 신청일</span>
        <span class="date">{{ GET_STD_YMD }}</span>
      </v-col>
      <v-col
        cols="12"
        class="pa-0 pt-5 pb-1 bt-line mt-3 d-flex justify-space-between"
      >
        <span class="label">근무유형</span>
        <span class="date">{{ GET_WORK_ORG_NM }}</span>
      </v-col>
      <v-col cols="12" class="pa-0 pt-4 bt-line mt-3 borderLine-outer">
        <div class="d-flex justify-space-between">
          <span class="borderLine-title">근무스케줄</span>
          <span class="date">{{ GET_SCHEDULE_TIME_NM }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import extraOptionsMixin from '@/mixins/extraOptionsMixin.js';

import { mapGetters } from 'vuex';

export default {
  mixins: [applCdMixin, extraOptionsMixin],
  data: () => ({
    chips: [],
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_STD_YMD',
      'GET_WORK_ORG_NM',
      'GET_SCHEDULE_TIME_NM',
    ]),
  },
  methods: {},
};
</script>

<style></style>
